import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as lib from '~/dependencies';
import * as actions from '~/store/actions';
import { ContactIntegrated } from '~/interfaces/integrations';
import SaveContactFormModal from './ContactFormModal';
import { Typography } from '../styles';

type Props = {
  contact: ContactIntegrated;
};

export default function SaveContact({ contact }: Props) {
  const dispatch = useDispatch();

  const { integrationInfo, integrationId, callId, phoneNumber } = contact;

  const [open, setOpen] = useState(false);

  // FIXME: We can improve the CreateIntegratedContactFormModal in typescript in the next refactor fase
  function handleSaveContactSubmit(
    companyId: string | number,
    name: string,
    lastName: string,
    contactType: any,
    observation: any,
    company: string
  ) {
    if (!lib._.isEmpty(name)) {
      dispatch(
        actions.createContact(
          phoneNumber,
          callId,
          // @ts-ignore
          integrationId,
          companyId,
          name,
          lastName,
          contactType,
          observation,
          company
        )
      );
      setOpen(false);
    }
  }

  return (
    <>
      <Typography onClick={() => setOpen(true)}>
        Save {phoneNumber} on {integrationInfo.name}
      </Typography>

      {open && (
        <SaveContactFormModal
          handleClose={() => setOpen(!open)}
          handleSubmit={handleSaveContactSubmit}
          integrationId={integrationId}
        />
      )}
    </>
  );
}
